module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('datepicker', {
    attrs: {
      "name": _vm.inputId,
      "id": _vm.inputId,
      "value": _vm.dateValue,
      "format": _vm.customFormatter
    },
    on: {
      "selected": function($event) {
        _vm.updatedDate($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6654b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/runtime-datepicker.vue
// module id = 564
// module chunks = 1